import type { ExpressModuleApi } from '@ekhodealer/ekho-common';
import type { ModuleDescriptor } from '../module-descriptor';

function noop(): void {}

export const expressDescriptor: ModuleDescriptor<ExpressModuleApi> = {
  name: 'express',

  fallbackApi: { mount: noop, unmount: noop },

  getBundleUrl(config) {
    if (config.disabled || !config.modules.express?.enabled) return null;
    return config.moduleManifest.express ?? null;
  },

  extractApi(loaded) {
    const api = loaded.api as Partial<ExpressModuleApi> | undefined;
    return {
      mount: typeof api?.mount === 'function' ? api.mount.bind(api) : noop,
      unmount: typeof api?.unmount === 'function' ? api.unmount.bind(api) : noop,
    };
  },
};
